import script from "./TextCardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCardComponent.vue?vue&type=script&setup=true&lang=js"

import "./TextCardComponent.vue?vue&type=style&index=0&id=b53f9416&lang=scss"

const __exports__ = script;

export default __exports__